const tag = {
  position: 'absolute',
  top: '-15px',
  right: '-25px',
  paddingX: 6,
  paddingY: 2,
  color: 'white',
  borderRadius: 'full',
  fontSize: 'sm',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  zIndex: 10,
};

const body = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: 6,
  borderRadius: 'xl',
  paddingX: 9,
  paddingBottom: 8,
  justifyContent: 'flex-start',
};

const button = {
  w: 'full',
  whiteSpace: 'break-spaces',
  textAlign: 'center',
};

export const style = {
  card: {
    width: 'xs',
    position: 'relative',
    overflow: 'show',
    height: 'fit-content',
  },
  pendingBody: {
    ...body,
    border: '2px solid',
    borderColor: 'yellow.400',
    paddingBottom: 8,
  },
  body,
  title: {
    fontSize: 'lg',
    fontWeight: 'bold',
    textAlign: 'center',
    minHeight: '47px',
  },
  text: {
    fontSize: 'md',
    textAlign: 'center',
    minHeight: '3rem',
  },
  button,
  preferredTag: {
    ...tag,
    bgColor: 'green.400',
  },
  pendingTag: {
    ...tag,
    bgColor: 'yellow.400',
  },
  pendingAlert: {
    status: 'warning',
    bgColor: 'yellow.200',
    borderRadius: 'xl',
    textAlign: 'center',
    fontSize: 'md',
    padding: 3,
    color: 'gray.500',
  },
  completeAlert: {
    width: 'full',
    status: 'info',
    borderRadius: 'xl',
    padding: '3',
  },
  completeButton: {
    ...button,
    bgColor: 'green.50',
    color: 'green.500',
  },
};
